import React, { useEffect, useState } from 'react'
import './OurActivities.scss'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

import { Pagination } from 'swiper/modules'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function OurActivities() {
  const [swiper, setSwiper] = useState(null)

  const handleOnSetSwiperOne = () => {
    swiper.slideTo(0)
  }

  // const handleOnSetSwiperTwo = () => {
  //   swiper.slideTo(1)
  // }

  const handleOnSetSwiperThree = () => {
    swiper.slideTo(1)
  }

  const handleOnSetSwiperFour = () => {
    swiper.slideTo(2)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='mainActivityAr' data-aos= 'fade-left'>
      <div className='slider'>
        <Swiper pagination={true} modules={[Pagination]} className='mySwiper' onSwiper={setSwiper}>
          <SwiperSlide>
            <div className="mainActivity_sliderOne">
              <h2 className="mainActivity_content">
                المنتجات الصناعية<br />
                الفولاذية
              </h2>
            </div>
          </SwiperSlide>
          {/* <SwiperSlide>
            <div className="mainActivity_sliderTwo">
              <h2 className="mainActivity_content">
                محطة النفايات البلدية الصلبة  <br />
                وإعادة التدوير والنفايات <br />
                لمشروع محطة توليد الكهرباء
              </h2>
            </div>
          </SwiperSlide> */}
          <SwiperSlide>
            <div className="mainActivity_sliderThree">
              <h2 className="mainActivity_content">
                تشييد المباني<br />
              </h2>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mainActivity_sliderFour">
              <h2 className="mainActivity_content">
                التجارة العامة<br />
              </h2>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='content'>
            <h2 className='title'>
              أنشطتنا الرئيسية 
            </h2>
            <h3 className='subtitle'>
              القوة الطاقة العالمية وتعمل الشركات الرائدة التابعة لشركائه في قطاع صناعة الصلب والبناء.            </h3>
            <div className='buttonsTr'>
              <div className='row_buttons'>
                <div className='button' onMouseEnter={handleOnSetSwiperOne}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      المنتجات الصناعية الفولاذية  
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      قضبان الأسلاك، حديد التسليح، سبائك  <br />
                      (البليت)، الصلب الأسلاك المجلفنة 
                    </div>
                  </div>
                </div>

                <div className='button3' onMouseEnter={handleOnSetSwiperThree}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      تشييد المباني
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      المشاركة والاستثمار في
                      مشاريع بناء
                    </div>
                  </div>
                </div>
                {/* <div className='button2' onMouseEnter={handleOnSetSwiperTwo}>
                  <div className='img'>
                    
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      محطة النفايات البلدية الصلبة وإعادة التدوير والنفايات لمشروع محطة ...  
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      مع عملية التغويز" تحويل النفايات ...
                    </div>
                  </div>
                </div> */}
              </div>

              <div className='row_buttons'>
                <div className='button4' onMouseEnter={handleOnSetSwiperFour}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      التجارة العامة
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      منتجات الصلب، البناء والمواد الصناعية والمعدنية، المعدات والآلات ...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
